// 260528nrai: GenoEasy iframe — ready → license → badok:load (GenoEasy Leitfaden)

const LICENSE_ACK_MESSAGE_TYPES = [
  'genoeasy:licensed',
  'genoeasy:license-ok',
  'genoeasy:license:ok',
  'genoeasy:license:accepted',
];

const READY_MESSAGE_TYPE = 'genoeasy:ready';
const READY_FALLBACK_MS = 12000;
const DATA_DELAY_AFTER_LICENSE_MS = 500;

let activeGenogramSession = null;

function normalizeOrigin(origin) {
  return String(origin || '').replace('127.0.0.1', 'localhost');
}

function originMatches(eventOrigin, expectedOrigin) {
  return normalizeOrigin(eventOrigin) === normalizeOrigin(expectedOrigin);
}

function logIframeMessage(event) {
  if (!event.data || !event.data.type) { return; }
  const messageType = String(event.data.type);
  if (!messageType.startsWith('genoeasy:') && !messageType.startsWith('badok:')) { return; }
  console.log('Genogramm [iframe→parent]', event.origin, messageType, event.data);
}

function handleGenoeasyMessage(event) {
  logIframeMessage(event);

  const session = activeGenogramSession;
  if (!session) { return; }
  if (!originMatches(event.origin, session.origin)) { return; }

  if (event.data.type === READY_MESSAGE_TYPE) {
    session.onReady();
    return;
  }

  if (LICENSE_ACK_MESSAGE_TYPES.includes(event.data.type)) {
    session.onLicenseAccepted(event.data.type);
    return;
  }

  if (event.data.type === 'badok:error') {
    console.error('Genogramm [badok:error]', event.data.reason || event.data);
    return;
  }

  if (event.data.type === 'badok:save') {
    console.log('Genogramm [badok:save] empfangen — Persistenz folgt separat');
  }
}

if (!window.genoeasyGenogramListenerAttached) {
  window.addEventListener('message', handleGenoeasyMessage);
  window.genoeasyGenogramListenerAttached = true;
}

function createGenogramSession(config) {
  const frame = document.getElementById(config.frameId);
  if (!frame) { return null; }

  return {
    frame: frame,
    origin: normalizeOrigin(config.origin),
    jwt: config.jwt,
    payload: config.payload,
    readyReceived: false,
    licenseSent: false,
    licenseAccepted: false,
    dataSent: false,
    timers: [],

    clearTimers() {
      this.timers.forEach((timerId) => window.clearTimeout(timerId));
      this.timers = [];
    },

    schedule(callback, delayMs) {
      const timerId = window.setTimeout(callback, delayMs);
      this.timers.push(timerId);
    },

    postToIframe(message) {
      if (!this.frame.contentWindow) { return false; }
      const iframeSrc = this.frame.getAttribute('src') || '';
      if (!iframeSrc || iframeSrc === 'about:blank') {
        console.warn('Genogramm: iframe src noch nicht gesetzt — postMessage übersprungen');
        return false;
      }
      try {
        this.frame.contentWindow.postMessage(message, this.origin);
        return true;
      } catch (error) {
        console.warn('Genogramm postMessage fehlgeschlagen:', error.message);
        return false;
      }
    },

    sendLicense(reason) {
      if (!this.jwt || this.licenseAccepted) { return false; }
      const licenseMessage = { type: 'genoeasy:license', token: this.jwt };
      if (!this.postToIframe(licenseMessage)) { return false; }
      this.licenseSent = true;
      console.log('Genogramm: genoeasy:license gesendet (' + reason + ')');
      return true;
    },

    sendData(reason) {
      if (this.dataSent || !this.payload.data.length) { return; }
      if (!this.postToIframe(this.payload)) { return; }
      this.dataSent = true;
      console.log('Genogramm: badok:load gesendet (' + reason + ')');
    },

    scheduleDataSend(reason) {
      this.schedule(() => {
        this.sendData(reason);
      }, DATA_DELAY_AFTER_LICENSE_MS);
    },

    onReady() {
      if (this.readyReceived) { return; }
      this.readyReceived = true;
      this.clearTimers();
      console.log('Genogramm: genoeasy:ready empfangen — Leitfaden: license, dann badok:load');
      this.sendLicense('nach genoeasy:ready');
      this.scheduleDataSend('nach genoeasy:ready + Lizenz');
    },

    onLicenseAccepted(reason) {
      if (this.licenseAccepted) { return; }
      this.licenseAccepted = true;
      console.log('Genogramm: Lizenz bestätigt (' + reason + ')');
      if (!this.dataSent) {
        this.scheduleDataSend('nach ' + reason);
      }
    },

    runReadyFallback() {
      if (this.readyReceived) { return; }
      console.warn('Genogramm: kein genoeasy:ready nach ' + READY_FALLBACK_MS + 'ms — Fallback license + load');
      this.sendLicense('Fallback ohne ready');
      this.scheduleDataSend('Fallback ohne ready');
    },

    runHandshake() {
      this.clearTimers();
      const parentOrigin = window.location.origin;
      console.log('Genogramm: parent origin=' + parentOrigin + ', iframe origin=' + this.origin);
      console.log('Genogramm: warte auf genoeasy:ready …');

      this.schedule(() => {
        this.runReadyFallback();
      }, READY_FALLBACK_MS);
    },
  };
}

export function mountGenoeasyGenogram(config) {
  if (activeGenogramSession) {
    activeGenogramSession.clearTimers();
  }

  activeGenogramSession = createGenogramSession(config);
  if (!activeGenogramSession) { return; }

  console.log('Genogramm: ' + config.payload.data.length + ' Beziehung(en) für badok:load');
  console.log('Genogramm payload:', config.payload);
  console.log('Genogramm iframe origin:', config.origin);

  if (!config.jwt) {
    console.error('Genogramm: JWT fehlt — GENOEASY_API_KEY / Partner-API prüfen');
    return;
  }

  activeGenogramSession.frame.addEventListener('load', () => {
    console.log('Genogramm: iframe load, src=' + activeGenogramSession.frame.getAttribute('src'));
    activeGenogramSession.runHandshake();
  });
}

window.mount_genoeasy_genogram = mountGenoeasyGenogram;

export function unmountGenoeasyGenogram() {
  if (activeGenogramSession) {
    activeGenogramSession.clearTimers();
  }
  activeGenogramSession = null;
}

window.unmount_genoeasy_genogram = unmountGenoeasyGenogram;
